import React from "react";
import { Route } from "react-router-dom";
import PageNotFound from "src/pages/PageNotFound";

export default [
	<Route path ="/" key="notFound" component={PageNotFound} />
];
